import React from "react";
import Icon from "components/AppIcon";

const PriceHeader = ({ stock }) => {
  const isPositive = stock?.change >= 0;

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-5">
      <div className="flex flex-wrap items-start justify-between gap-4">
        {/* Left: Symbol & Name */}
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 border border-border"
            style={{ background: "rgba(0,217,255,0.1)" }}>
            <span className="font-heading text-xs md:text-sm font-bold" style={{ color: "var(--color-primary)" }}>
              {stock?.symbol?.slice(0, 2)}
            </span>
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h1 className="font-heading text-lg md:text-xl font-bold text-foreground">{stock?.symbol}</h1>
              <span className="px-2 py-0.5 rounded text-xs font-caption border border-border text-muted-foreground">{stock?.exchange}</span>
              <span className="px-2 py-0.5 rounded text-xs font-caption"
                style={{ background: "rgba(0,217,255,0.08)", color: "var(--color-primary)", border: "1px solid rgba(0,217,255,0.2)" }}>
                {stock?.sector}
              </span>
            </div>
            <div className="text-sm text-muted-foreground truncate">{stock?.name}</div>
          </div>
        </div>

        {/* Right: Price */}
        <div className="text-right flex-shrink-0">
          <div className="font-heading text-2xl md:text-3xl font-bold text-foreground">
            ${stock?.price?.toFixed(2)}
          </div>
          <div className={`flex items-center justify-end gap-1 text-sm font-semibold font-caption`}
            style={{ color: isPositive ? "var(--color-success)" : "var(--color-error)" }}>
            <Icon name={isPositive ? "TrendingUp" : "TrendingDown"} size={14} color={isPositive ? "var(--color-success)" : "var(--color-error)"} />
            {isPositive ? "+" : ""}{stock?.change?.toFixed(2)} ({isPositive ? "+" : ""}{stock?.changePct?.toFixed(2)}%)
          </div>
          <div className="text-xs text-muted-foreground font-caption mt-0.5">
            Vol: {stock?.volume?.toLocaleString()} · Updated just now
          </div>
        </div>
      </div>
      {/* Stats Row */}
      <div className="grid grid-cols-3 md:grid-cols-6 gap-3 mt-4 pt-4 border-t border-border">
        {[
          { label: "Open", value: `$${stock?.open?.toFixed(2)}` },
          { label: "High", value: `$${stock?.dayHigh?.toFixed(2)}`, color: "var(--color-success)" },
          { label: "Low", value: `$${stock?.dayLow?.toFixed(2)}`, color: "var(--color-error)" },
          { label: "Prev Close", value: `$${stock?.prevClose?.toFixed(2)}` },
          { label: "Bid", value: `$${stock?.bid?.toFixed(2)}` },
          { label: "Ask", value: `$${stock?.ask?.toFixed(2)}` },
        ]?.map(s => (
          <div key={s?.label} className="text-center">
            <div className="text-xs text-muted-foreground font-caption">{s?.label}</div>
            <div className="font-mono text-sm font-semibold mt-0.5" style={{ color: s?.color || "var(--color-foreground)" }}>{s?.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PriceHeader;